/**
 * Паттерны для определения технических/серверных ошибок,
 * которые не должны показываться пользователю напрямую.
 * Включают: стек трейсы Laravel/PHP, пути к файлам, SQL-ошибки и т.д.
 */
export const TECHNICAL_ERROR_PATTERNS: RegExp[] = [
    /SQLSTATE/i,
    /stack trace/i,
    /undefined index/i,
    /attempt to read property/i,
    /call to a member function/i,
    /vendor\/laravel/i,
    /\/var\/www/i,
    /Illuminate\\/i,
    /Symfony\\/i,
    /TypeError:/i,
    /ReferenceError:/i,
    /ErrorException/i,
    /QueryException/i,
    /PDOException/i,
    /#\d+\s+\/var\//i,
    /at line \d+/i,
    /in \/var\//i,
];

export function isTechnicalError(message: string): boolean {
    return TECHNICAL_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}
